import * as messageService from "../../services/message.service";
import * as driversLicenceTypeService from '../../services/driversLicenceType.service';


const state = {
    driversLicenceTypeAll:[],
    driversLicenceTypeAllActive:[],
};

const getters = {
    gettDriversLicenceTypeAll:state => (state.driversLicenceTypeAll),
    gettDriversLicenceTypeAllActive:state => (state.driversLicenceTypeAllActive),
};

const actions = {
    async fetchDriversLicenceTypeAll({ commit } ){
        try {
            const response = await driversLicenceTypeService.all();
            commit('setDriversLicenceTypeAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDriversLicenceTypeAllActive({ commit } ){
        try {
            const response = await driversLicenceTypeService.allActive();
            commit('setDriversLicenceTypeAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setDriversLicenceTypeAll:(state, res) => (
        state.driversLicenceTypeAll =  res
    ),
    setDriversLicenceTypeAllActive:(state, res) => (
        state.driversLicenceTypeAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}